import { combineReducers } from 'redux'

import { administrationOptionsReducer } from './administrationOptionsReducer'
import { administrationReducer } from './administrationReducer'

export default combineReducers({
  detail: administrationReducer,
  options: administrationOptionsReducer
})
